export default {
  data() {
    return {
      provinceData: [],
      cityData: [],
      areaData: [],
      pcaCode: null
    }
  },
  computed: {
    country() {
      return this.chartOption.name.split("/")[0]
    },
    province() {
      const nameList = this.chartOption.name.split("/")
      const province = nameList.length > 1 ? nameList[0].split(".")[0] : "全国"
      this.initCitysData(this.chartOption.name)
      return province
    },
    city() {
      this.initAreaData(this.chartOption.name)
      const nameList = this.chartOption.name.split("/")
      if (nameList.length > 1) {
        const cityName = nameList[1].split(".")[0]
        if (cityName === this.province) {
          return ""
        } else return cityName
      } else return ""
    },
    area() {
      const nameList = this.chartOption.name.split("/")
      if (nameList.length === 3 && nameList[1] !== nameList[2].split(".")[0]) {
        return nameList[2].split(".")[0]
      } else return ""
    }
  },
  methods: {
    initProvinceData() {
      const _provinceData = []
      this.pcaCode.forEach(province => {
        _provinceData.push({ value: province.code, label: province.name })
        this.provinceData = _provinceData
      })
    },
    initCitysData(name) {
      if (name === "" || name === "全国") return
      const _cityData = []
      let citys = this.pcaCode.find(province => province.name === name.split("/")[0])
      if (citys && citys.children.length === 1) {
        //直辖市没有更下一级 所以直接获取下一级
        citys = citys.children[0]
      }
      citys.children.forEach(city => {
        _cityData.push({ value: city.code, label: city.name })
      })
      this.cityData = _cityData
    },
    initAreaData(name) {
      if (name.split("/").length < 3) return
      const province = this.pcaCode.find(province => province.name === this.province)
      const areas = province.children.find(city => city.name === name.split("/")[1])
      const res = []
      areas.children.forEach(area => {
        res.push({ value: area.code, label: area.name })
      })
      this.areaData = res
    },
    changeProvince(provinceCode) {
      if (!provinceCode) {
        this.$changeOptionsEV("全国", "chartOption.name", false, false, false, true)
      } else {
        const name = this.provinceData.find(item => item.value === provinceCode).label
        const jsonLocation = `${name}/${name}.${provinceCode + new Array(6 - provinceCode.length).fill(0).join("")}`
        this.$changeOptionsEV(jsonLocation, "chartOption.name", false, false, false, true)
      }
    },
    changeCity(cityCode) {
      let porvince = this.pcacode.find(province => province.name === this.province)
      let specialProvince
      if (porvince.children.length === 1) {
        //处理直辖市
        specialProvince = 1
        porvince = porvince.children[0]
      }
      const city = porvince.children.find(city => city.code === cityCode)
      const jsonLocation = `${this.province}/${specialProvince ? "" : city.name + "/"}${city.name}.${
        city.code + new Array(6 - city.code.length).fill(0).join("")
      }`
      this.$changeOptionsEV(jsonLocation, "chartOption.name", false, false, false, true)
    },
    changeArea(areaCode) {
      const names = this.chartOption.name.split("/")
      const porvinces = this.pcaCode.find(porvince => porvince.name === names[0])
      const cities = porvinces.children.find(city => city.name === names[1])
      const area = cities.children.find(area => area.code === areaCode)
      const jsonLocation = `${porvinces.name}/${cities.name}/${area.name}.${area.code}`
      this.$changeOptionsEV(jsonLocation, "chartOption.name", false, false, false, true)
    }
  },
  created() {
    if (localStorage.getItem("pca-code")) {
      this.pcaCode = JSON.parse(localStorage.getItem("pca-code"))
      this.initProvinceData()
    } else {
      this.instance.get("sv2/assets/map/pca-code.json").then(res => {
        const data = res.data
        this.pcaCode = data
        window.localStorage.setItem("pca-code", JSON.stringify(data))
        this.initProvinceData()
      })
    }
  }
}
